import React from "react";
import getColor  from "../utils/interpolateColor";
import { useTranslation } from "../hooks/useTranslation";

const CircleChart = ({
  value = 75,
  size = 64,
  strokeWidth = 8,
  bgColor = "#e5e7eb",
  label = "",
  textColor = "#111827",
  darkMode = false,
}) => {
  const normalizedRadius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const strokeDashoffset = circumference - (clamped / 100) * circumference;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center">
      <svg width={size} height={size}>
        <circle
          stroke={bgColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke={getColor(clamped)}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
          style={{
            transform: "rotate(-90deg)",
            transformOrigin: "50% 50%",
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset,
            transition: "stroke-dashoffset 0.4s ease",
          }}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          fontSize={size * 0.28}
          fontWeight={700}
          fill={darkMode ? "#f9fafb" : textColor}
        >
          {Math.round(clamped)}
        </text>
      </svg>
      {label ? (
        <span className={`mt-1 text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {t(label)}
        </span>
      ) : null}
    </div>
  );
};

export default CircleChart;


